module.exports = __webpack_public_path__ + "files/framework4-service-communication-applications.92ac6ae4.pdf";